<template>
  <div>
    <el-card :body-style='titleCard' style="position: relative; " class="title">
      <el-row class="item" style="background:#fff">
        <el-col :span="14">
          <div class="pro-content">
            <!-- <span class="proTitle">{{title.title}}</span>
            <span> <el-button @click="showTitle" >click</el-button></span> -->
            <div style="padding: 15px 0; width: 100% ;word-wrap: break-word;  word-break: normal;">
              <span v-for="item in titleList" class="proTitle" :key="item.projectName" @click="titleClick(item)">{{
                item.seq + item.projectName }} <span class="el-icon-d-arrow-right" style="font-weight: 600;"
                  v-show="item.spe"></span> </span>
            </div>
            <div class="pro-des">
              <span style="font-weight:600;margin-right:5px;">{{ title.type }}</span>
              <span v-if="!!title.des">·</span>
              <span>{{ title.des }} </span>
            </div>
          </div>
          <WorkflowBtn style="margin:15px 0 0 10px;" :titleInfo='title' :statusList='statusList'
            @deletePage='deletePage' @saveRoute='reload' :disableDel="disableDel" :directorDisable="directorDisable"
            @reloadNewPage='reloadPage'>
            <el-button size="small" style="margin-left:10px" @click="getBrowser"> <i
                class="icon iconfont icon-shuzhuang xx-icon"></i> {{ $t('message.button.TreeView') }}</el-button>
            <el-button size="small" style="margin-left:10px" @click="openGanttChart"> <i
                class="icon iconfont icon-shuzhuang xx-icon"></i> {{ $t('message.button.gantt') }}</el-button>

            <!-- <el-button size="small" style="margin-left:10px" @click="openXX"> <i
                class="icon iconfont icon-shuzhuang xx-icon"></i> 关键路径 </el-button> -->
          </WorkflowBtn>

        </el-col>
        <el-col :span="5">
          <div class="progress">
            <el-progress type="dashboard" :width='120' :percentage="percentage" :color="colors[statusTypes[0].type]"
              :format="format"></el-progress>
          </div>
        </el-col>
        <el-col :span="5">
          <div style="margin:30px 0 0 5px">
            <Light v-for="item in statusTypes" :statusType="item" :key="item.index"></Light>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <!--    <div>-->
    <!--      <el-dialog-->
    <!--          title="甘特图"-->
    <!--          :visible.sync="openDialog"-->
    <!--          width="80%"-->
    <!--          :before-close="handleClose">-->

    <!--        <div>-->
    <!--          <gantt class="left-container" :tasks="tasks"></gantt>-->
    <!--        </div>-->
    <!--        &lt;!&ndash;        <span slot="footer" class="dialog-footer">&ndash;&gt;-->
    <!--        &lt;!&ndash;&lt;!&ndash;    <el-button @click="dialogVisible = false">取 消</el-button>&ndash;&gt;&ndash;&gt;-->
    <!--        &lt;!&ndash;&lt;!&ndash;    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>&ndash;&gt;&ndash;&gt;-->
    <!--        &lt;!&ndash;  </span>&ndash;&gt;-->
    <!--      </el-dialog>-->
    <!--    </div>-->
    <div class="nav">
      <Navbar @tabClick='tabClick' :navList='tabList'></Navbar>
    </div>

    <div class="route-content">
      <router-view :reloadNewRouter="reloadRouter" :tableInfo='tableInfo' :rootId='rootId' @routeClick="reload"
        @deletePage='deletePage' @reloadProgress="reloadPage" v-if="isRouterAlive">
      </router-view>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Navbar from "./components/navbar.vue";
import '@/assets/css/icon-swift.css';
import Light from "./components/light.vue";
import WorkflowBtn from "./components/workflowBtn.vue";
import { projectTabList } from "@/utils/publicstate";
import { getTabIndex } from "@/utils/index.js"
export default {
  name: 'project',
  data() {
    return {
      titleCard: { padding: "0px" },
      percentage: 0,
      colors: ["#13ce66", "#fcad2c", "#f56c6c"],
      statusTypes: [
        { name: this.$t('message.title.ScheduleStatus'), type: 0 },
        { name: this.$t('message.title.CostStatus'), type: 0 },
        { name: this.$t('message.title.ResourceStatus'), type: 0 },
        // { name: "成本状态", type: 0 },
        // { name: "资源状态", type: 0 },
      ],
      // type:0,
      // typeList:['未开始','进行中','已完成','拒绝','逾期'],
      tabList: [],
      title: {
        name: "",
        des: "",
        statusLabel: "...",
      },
      userList: [],
      statusList: [],
      tableInfo: [],

      titleList: [],

      deletePriv: false,
      reloadRouter: false,
      isRouterAlive: true,
      disableDel: false,
      directorDisable: false,
      rootId: '',
    };

  },
  components: {
    Navbar,
    Light,
    WorkflowBtn,
  },

  methods: {
    // getScheduleLeaf(val) {
    //   if (val) {
    //     this.getNextState();
    //   }
    // },
    titleClick(item) {
      console.log(item);
      item.title = item.projectName;
      if (item.spe) {
        this.getLink(item);
        this.$store.commit('setPageRefresh');
      }

    },
    showTitle() {
      const n = this.titleList.map(i => i.projectName).join('/')
      this.$set(this.title, 'title', n)
      // this.title.title = this.titleList.map(i  => i.projectName).join('/') + '/'+  this.title.name;
    },

    // getWBS(e){
    //   axios
    //     .get('/ppm/project/getProjectBrowserInfo?rootId='+e)
    //     .then((res) => {
    //       console.log(res);
    //       // this.transData([res.data.object.Info])

    //       const getListName = function(array, l, n) {

    //         if (!array || !array.length) return;
    //         let level = l || 1;
    //         let parentLevel = n || 0;
    //         array.map((item, e) => {
    //           item.seq = !parentLevel ? (e+1+'') : parentLevel +'.'+ (e+1+'')
    //           if (item.childProject && item.childProject.length) {
    //             getListName(item.childProject, level + 1, item.seq);
    //           }
    //         })
    //         // console.log(array);
    //         return newArr;
    //       };
    //       const listData = getListName(res.data.object.Info.childProject);
    //       console.log(listData);
    //   })
    // },

    getWBS() {
      var obj_get = {
        ... this.$store.state.objectId,
        tableId: 54,
      };
      axios
        .get(`/ppm/project/getScheduleTableList${this.params(obj_get)}`)
        .then(res => {
          let arr = this.transData(res.data.object.table.rows);
          this.getItemSeq(arr[0].children)
          // console.log(arr,this.titleList);
          arr = this.getAllRow(arr);
          console.log(arr, this.titleList);
          this.titleList.forEach(i => {
            let seq = arr.find(j => j.id === i.id).seq;
            i.seq = !seq ? "" : seq + '.'
          })
          console.log(this.titleList);
          // .shift();
          // axios.post("/ppm/project/updateProjectDisplayOrderByProjects",{ProjectList:arr}).then(res =>{
          //   console.log(res);
          // })
        })

    },
    transData(arr) {
      let newArr = [];
      arr.map((i) => {
        let n = {
          id: i.objId,
          projectNumber: i.projectNumber
        }
        newArr.push(n);
        if (i.children) {
          n.children = this.transData(i.children);
        }
      });
      return newArr;
    },
    getBrowser() {
      console.log(this.rootId);
      this.$emit('getBrowserPage', this.rootId)
    },
    // 打开甘特图
    openGanttChart() {
      var obj_get = {
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        tableId: 54,
      };
      let tableData = {}
      axios.get(`/ppm/project/getScheduleTableList${this.params(obj_get)}`).then((res) => {
        if (res.data.code == 200) {
          tableData = res.data.object.table;
          const routeData = this.$router.resolve({
            path: '/Gantt',
          })
          let json = JSON.stringify(tableData)
          // console.log(json)
          sessionStorage.setItem("data", json);
          window.open(routeData.href, "_blank");
        }
      })
    },
    openXX() {
      const routeData = this.$router.resolve({
        path: '/criticalPath',
      })
      window.open(routeData.href, "_blank");
    },

    checkDelPriv(e) {
      //console.log(e);
      if (e) {
        const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;
        const privsArr = arr.map((i) => {
          return i.type;
        });
        if (privsArr.indexOf(25) != -1) {
          this.deletePriv = true;
        }
      }
    },
    routerReload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
        // console.log('routerReload')
      });
    },
    format(percentage) {
      // return `  ${percentage}% ${this.typeList[this.type - 1]} `;

      return this.percentage + "%" + "\n\n" + this.title.statusLabel;
    },
    // getTab(e) {
    //   this.$router.push(this.tabList[e].path);
    // },
    tabClick(res) {

      this.$router.push({
        path: res.path,
        query: { ...this.$store.state.objectId },
      });

    },
    deletePage(e) {
      // console.log(e);
      this.$emit("deletePage");
      // console.log(this.$parent);
      // this.$parent.cc();
    },
    reload(e) {
      if (e == undefined) {
        this.getItemData();
        this.getProjectStatusById();
        // this.getBrowser();
        return;
      }
      const obj = {
        id: e.itemId,
        classId: e.itemClassId,
        subClassId: e.itemSubClassId,
        title: e[0]
      };
      this.getLink(obj);
      this.$store.commit("setPageRefresh");
    },
    getItemData() {
      var obj_get = {
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
        //classId: this.$store.state.classId_,
        //subClassId: this.$store.state.subClassId_,
        tableId: 1,
      };
      axios.get(`/ppm/project/loadTable${this.params(obj_get)}`).then((res) => {
        if (res.data.code == 200) {

          const { rootId, table, userList } = res.data.object

          this.$store.commit("setProjectCreatedBy", table.createdBy);
          //console.log(res);
          this.rootId = rootId;

          this.$store.commit('setProjectRootId', this.rootId)
          const list = userList.map(i => (
            {
              value: i.id + '',
              label: i.loginId + "(" + (i.userName || "") + ")",
            }
          ))
          this.$store.commit('setUserList', list)

          this.tableInfo = res.data.object;

          const val = table.rows[0].cells;
          let arr = this.getNewData(table.columnInfo);
          arr.map((i, e) => {
            i.val = val[e];
          });


          this.title = {
            name: arr.find((i) => i.id == 1051012)?.val.val || '',
            type: arr.find((i) => i.id == 1051009)?.val.val || '',
            des: arr.find((i) => i.id == 1051013)?.val.val || '',
            status: arr.find((i) => i.id == 1051019)?.val.id || '',
            statusLabel: arr.find((i) => i.id == 1051019)?.val.val || '',
          };

          // console.log(this.title);
          this.title.title = this.title.name;

          this.titleList = JSON.parse(table.rows[0].projectObjArray).map((i, e) => ({ ...i, spe: !e ? '' : '/ ', seq: ' ' })).reverse()
          // console.log(this.titleList);
          // this.updateTabName(this.title.name);
          this.getWBS(this.rootId);



          let isAdminUser = arr.find((i) => i.id == 1051010)?.val.ids.split(";") || "";
          let isDirector = arr.find((i) => i.id == 1051011)?.val.ids.split(";") || "";
          let userId = window.sessionStorage.getItem("userContext");
          userId = JSON.parse(userId).id;

          let userIndex_ = isAdminUser.indexOf(userId + "");
          let directorIndex_ = isDirector.indexOf(userId + "");

          this.$store.commit("setIsProjectAdmin", userIndex_);
          this.$store.commit("setIsProjectDirector", directorIndex_);

          this.directorDisable = directorIndex_ != -1
          this.disableDel = userIndex_ !== -1 || !this.$store.state.isSuperAdmin;
          this.$store.commit("setAllProjectBtnDisable", this.title.status == -1);


          const m = table.columnInfo.listEntries["501"];
          this.statusList = Object.keys(m).map((i) => {
            return { value: i, label: m[i] };
          });

          let description_ = this.title.des ? ":" + this.title.des : "";


          const tabs = this.$store.getters.getShowingTabInHome; //已存在的list数据
          let currentTab = tabs.find(
            (i) => i.objId == this.$store.state.objectId.id
          );

          if (
            !!currentTab &&
            this.$store.state.objectId.id != rootId
          ) {
            currentTab.rootId = setCheckrootId;
            this.$store.commit("replaceShowingTabsInHome", tabs);
          }

          // let activeName = this.$store.getters.getActivedTabInHome;
          //添加最近访问
          this.addRecentVistInCommon({
            baseClassId: this.Constants.projectBaseClassId,
            number: this.title.name,
            ... this.$store.state.objectId,
            //id: this.$store.state.objId_,
          });

          this.updateFavoriteInCommon({
            baseClassId: this.Constants.projectBaseClassId,
            number: this.title.name,
            ... this.$store.state.objectId,
            //id: this.$store.state.objId_,
          });
        }
      }).catch((err) => {
        // console.log(err);
        // this.objectDelConfirm('deletePro')
      })
      // .catch(this.objectDelConfirm('deletePro'))
    },
    // goToState(num) {
    //   //console.log(num);
    //   this.updateState(num);
    // },
    // updateState(stateId) {
    //   let stateVal = {
    //     projectId: this.$store.state.objId_,
    //     targetStatusId: stateId,
    //   };
    //   axios.post("/ppm/project/changeProjectStatus",stateVal).then(res =>{
    //     console.log(res);
    //   })
    // },
    // getNextState() {
    //   this.statusInfo = [];
    //   axios
    //     .get(
    //       "/ppm/project/getProjectStatusListById?id=" + this.$store.state.objId_
    //     )
    //     .then((res) => {
    //       if (res.data.object.projectStatusList.length) {
    //         this.statusInfo = res.data.object.projectStatusList;
    //       } else {
    //         this.StatusBtn = true;
    //         this.signoffButton = false;
    //       }
    //     });
    // },
    getTabData() {
      axios
        .get("/pmdm/admin/getTab/" + this.$store.state.objectId.subClassId)
        .then((res) => {
          this.tabList = res.data.object.tabs.map(i => {
            i.path = projectTabList.find(j => j.id == i.id)?.path || ''
            return i;
          })
          const tabIndex = getTabIndex({ ...this.$store.state.objectId })?.index || 0
          this.tabClick(projectTabList.find(j => j.id == this.tabList[tabIndex].id))

          return
        });
    },
    reloadPage(val) {
      this.reloadRouter = val;
      //console.log(this.reloadRouter);
      this.getItemData();
      this.getProjectStatusById();
      this.routerReload();
    },

    getProjectStatusById() {
      axios
        .get(
          "/ppm/project/getProjectStatusById?projectId=" +
          this.$store.state.objectId.id
        )
        .then((res) => {
          // console.log(res);
          this.$emit('projectStatusChange', this.rootId);    //如果项目状态变更时，树状图前面的颜色及时变更
          this.statusTypes = [
            { name: this.$t('message.title.OverallStatus'), type: 0 },
            { name: this.$t('message.title.ScheduleStatus'), type: 0 },
            { name: this.$t('message.title.CostStatus'), type: 0 },
            { name: this.$t('message.title.ResourceStatus'), type: 0 },
            // { name: "总体状态", type: 0 },
            // { name: "计划状态", type: 0 },
            // { name: "成本状态", type: 0 },
            // { name: "资源状态", type: 0 },
          ];
          const info = res.data.object.Info;
          this.percentage = info.percentComplete;
          this.statusTypes[3].type = !info.timeHealth ? 0 : 2;
          this.statusTypes[2].type = !info.costHealth ? 0 : 2;
          // this.statusTypes[1].type = info.statusType < 5 ? 0 : 2;

          // =5: rate; >5 warning; <5 normal;
          const v = 5 - info.statusType;
          this.statusTypes[1].type = !v ? 2 : (v > 0 ? 0 : 1)

          const statusTypeList = this.statusTypes.map(i => i.type);
          this.statusTypes[0].type = statusTypeList.includes(2) ? 2 : (!statusTypeList.includes(1) ? 0 : 1)
          //
        });
    },
  },
  mounted() {

  },
  created() {

    const { id, classId, subClassId } = this.$route.query;
    const obj = { id, classId, subClassId };
    this.$store.commit('setObjectId', obj);
    this.getItemData();
    console.log(projectTabList);
    this.getTabData();
    // this.getNextState();
    this.getProjectStatusById();
  },
};
</script>
<style>
.progress .el-progress--dashboard .el-progress__text {
  white-space: pre-wrap;
}
</style>

<style scoped>
.route-content {
  padding: 10px 15px;
  height: calc(100vh - 320px);
  overflow-y: scroll;
}

.pro-content {
  margin-left: 20px;
  width: 100%;
  word-wrap: break-word;
  word-break: normal;

}

.proTitle {
  font-size: 20px;
  font-weight: bold;
  color: #4b92ff;
  /* width: 500px; */
  overflow: hidden;
  white-space: nowrap;
  /*规定文本不进行换行*/
  text-overflow: ellipsis;
  cursor: pointer;
}

.xx-icon {
  font-size: 12px;
  /* transform: rotate(90deg) rotateY(180deg); */
}

.pro-des {
  margin-left: 5px;
  overflow: hidden;
  white-space: nowrap;
  /*规定文本不进行换行*/
  text-overflow: ellipsis;
}

.title {
  min-height: 130px;
  z-index: 99;
}

.item {
  min-height: 136px;
}

.item-title {
  /* width: 68%; */
  word-wrap: break-word;
  word-break: normal;
}

.progress {
  margin: 10px 0 0 5px;
  position: relative;
}

.progress .el-progress-circle {
  height: 86px;
  width: 86px;
}

/* .nav {
  padding-left: 15px;
  border-bottom: 2px solid #fff;
   box-sizing: content-box;
  z-index: -1;
} */
</style>
